<template>
    <div v-if="field">
        <b-input-group>
            <b-input-group-prepend v-if="$attrs.prefix">
                <b-input-group-text> {{ $attrs.prefix }} </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input 
            type="email" 
            :id="field.key" 
            :placeholder="field.constraints.placeholder"
            v-model="content"
            autocomplete="off"
            v-bind="$attrs"
            ></b-form-input>
            <b-input-group-prepend v-if="$attrs.sufix">
                <b-input-group-text> {{ $attrs.sufix }}</b-input-group-text>
            </b-input-group-prepend>

            <custom-template :content="field.template" :data="{field: field, value: content}" :key="field.key" />

            <b-form-invalid-feedback :id="field.key" style="display:block" v-if="allErrors !== undefined && allErrors.length > 0">
                {{ translateExtendedError(allErrors[0]) || null }}
            </b-form-invalid-feedback>

            <b-form-invalid-feedback :id="field.key" style="display:block" v-else>
                {{ errors[0] || null }}
            </b-form-invalid-feedback>

         </b-input-group>
    </div>
</template>

<script>
import CustomTemplate from "../CustomTemplate.vue"

export default {
    name: "IdentityField_Text",
    components: { CustomTemplate },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number | Object,
            default: null
        },
        extendErrors: {
            type: Array
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            errorTrans: {
                email_already_exists: "Email already exists",
                unique: "This field must be unique",
                invalid: "Invalid value"
            }
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        allErrors: {
            get() {
                return this.extendErrors
            },

            set(val) {
                this.errors = val
            }   
        }
    },
    watch: {
        content: function(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            val = val || ""

            this.errors = []
            this.allErrors = []

            if (val == "" && this.constraints.required) {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.field.type != 'email') {
                if (this.constraints.length !== undefined) {
                    if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                        if (val.length > this.constraints.length.max && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeMoreThenChars", {
                                    max: this.constraints.length.max
                                })
                            )
                        }
                    }
                    
                    if (this.constraints.length.min !== null) {
                        if (val.length < this.constraints.length.min && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeLessThenChars", {
                                    min: this.constraints.length.min
                                })
                            )
                        }
                    }
                }

                if (val.length > 0) {
                    if (this.constraints.not_allowed_words !== undefined) {
                        let notAllowedWords = this.constraints.not_allowed_words.split(",")
                        notAllowedWords.forEach(word => {
                            word = word.trim()

                            if (word != "") {
                                if (val.indexOf(word) !== -1) {
                                    if (word.length < 2) {
                                        this.errors.push(
                                            this.translator("identityField.symbolNotAllowed", {
                                                symbol: word
                                            })
                                        )
                                    } else {
                                        this.errors.push(
                                            this.translator("identityField.wordNotAllowed", {
                                                word: word
                                            })
                                        )
                                    }
                                }  
                            }              
                        })
                    }

                    if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                        let re = new RegExp(this.constraints.regex)
                        if (! re.test(val)) {
                            this.errors.push(this.translator("identityFields.invalidInput"))
                        }
                    }
                }
            }
        

            if (this.field.type == "email" && val.length > 0) {
                let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
                if (! re.test(val)) {
                    this.errors.push(this.translator("identityField.invalidEmail"))
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length})
        },

        translateExtendedError(err) {
            return this.errorTrans[err] || err
        }
    },
    mounted() {
        if (this.constraints.default && this.content === null) {
            this.content = this.constraints.default
            return
        }

        this.check(this.content)
    }
}
</script>